import { RefabricProURL } from "../index";
import { ApiResponse } from "../HttpClient";
import blogService from "../blog/blog.service";
import { IBlogPostListResponse } from "../blog/blog.type";
import { IUtilsImageRemoveBackgroundRequest, IUtilsImageDescribeRequest, IUtilsUploadPatternRequest, IUtilsContactUsRequest } from "./utils.type";

export default {
  async removeBackground(data: IUtilsImageRemoveBackgroundRequest, options?: any): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`utils/remove_bg`, data, options);
  },
  async describeImage(data: IUtilsImageDescribeRequest, options?: any): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`utils/describe`, data, options);
  },
  async uploadPattern(data: IUtilsUploadPatternRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`utils/upload_pattern`, data, {});
  },
  async getUploadedPatterns(): Promise<ApiResponse<any>> {
    return await RefabricProURL.get(`utils/upload_pattern`, {});
  },
  async contactUs(data: IUtilsContactUsRequest): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`utils/contacts`, data, {});
  },
  async getMagicSelectMasks(image_path: string, options?: any): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`utils/magic-selection-points`, { image_path: image_path }, options);
  },
  async generateUploadUrl({ file_name, content_type }: { file_name: string; content_type?: any }): Promise<ApiResponse<any>> {
    return await RefabricProURL.post(`utils/generate_upload_url`, { content_type, file_name });
  },
  async generateUrl({ file_name }: { file_name: string }): Promise<ApiResponse<any>> {
    return await RefabricProURL.get(`utils/generate_url`, { params: { file_name } });
  },
  // Blog now comes from the ref-api Blog CMS (/v1/blog), replacing the legacy
  // WordPress-proxied /v1/statics/blogs. Returns the new { data, page } shape.
  async getBlogs(pageSize = 3): Promise<IBlogPostListResponse> {
    return await blogService.listPosts({ page_size: pageSize });
  },
};
